import { gql } from '@apollo/client';

export const CREATE_ENROLLING_USER = gql`
  mutation Flex_CreateEnrollingUser($input: EnrollingUserInput!) {
    enrollingUser: createEnrollingUser(input: $input) {
      id
      token
      user {
        id
        email
        signupFunnelLeadId
      }
    }
  }
`;
